var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-secondary-1 py-2 px-1 board-radius" },
    _vm._l(_vm.details, function(detail, idx) {
      return _c("div", { key: idx }, [
        _c(
          "div",
          {
            class: `row mx-1 ${idx == 0 ? "p-2 bg-white board-radius" : "mt-2"}`
          },
          _vm._l(detail, function(item) {
            return _c(
              "div",
              {
                key: item.label,
                class: `${
                  Boolean(item.cols) ? String(item.cols) : "col-sm w-50"
                }`
              },
              [
                _c("div", { staticClass: "d-flex" }, [
                  item.mainIcon
                    ? _c(
                        "div",
                        {
                          staticClass: "d-flex align-items-center",
                          class: item.containerClass
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "dot text-center d-flex justify-content-center align-items-center mt-n1"
                            },
                            [
                              _c("em", {
                                staticClass: "color-white font-20",
                                class: item.icon
                              })
                            ]
                          ),
                          _c(
                            "span",
                            { staticClass: "font-14", class: item.dataClass },
                            [_vm._v(" " + _vm._s(item.data) + " ")]
                          )
                        ]
                      )
                    : _vm._e(),
                  item.icon && !item.mainIcon
                    ? _c("em", {
                        staticClass: "pt-1 mr-2 text-orange",
                        class: item.icon
                      })
                    : _vm._e(),
                  !item.mainIcon
                    ? _c("div", [
                        _c("span", { staticClass: "font-12 color-gray-6" }, [
                          _vm._v(_vm._s(item.label))
                        ]),
                        _c(
                          "p",
                          {
                            staticClass: "font-14 color-black",
                            class: item.dataClass
                          },
                          [_vm._v(" " + _vm._s(item.data) + " ")]
                        )
                      ])
                    : _vm._e()
                ])
              ]
            )
          }),
          0
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }